export const BaseLineClipboard = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.5 3.5H8H5C4.44771 3.5 4 3.94771 4 4.5V21C4 21.5523 4.44771 22 5 22H19C19.5523 22 20 21.5523 20 21V4.5C20 3.94771 19.5523 3.5 19 3.5H16.525H15.5"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M14 2H10C9.17157 2 8.5 2.67157 8.5 3.5C8.5 4.32843 9.17157 5 10 5H14C14.8284 5 15.5 4.32843 15.5 3.5C15.5 2.67157 14.8284 2 14 2Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
